module.exports = __webpack_public_path__ + "img/trophy.ea43f92e.png";